import LoyaltyBanner from "../../../LoyaltyBanner";
import LoyaltyMembersDayBannerButton from "./Button";
import keychainImage from "./Members_Collectibles_ax3cjz.webp";
import PropTypes from "prop-types";
import { withTranslation } from "../../../translation";

const BannerContent = ({ formatTranslation, membersDayEvent }) => {
  const loyaltyCopyTranslation =
    membersDayEvent === "MembersSaleLive"
      ? "web_members_day_live_plp_banner_body_copy"
      : "web_members_day_plan_your_buy_banner_copy";

  const loyaltyMembersDayBannerButtonComponent = () => (
    <LoyaltyMembersDayBannerButton
      copy={formatTranslation("web_members_day_plp_banner_button_copy")}
    />
  );

  return (
    <LoyaltyBanner
      header={formatTranslation("web_members_day_plp_banner_title")}
      copy={formatTranslation(loyaltyCopyTranslation)}
      Button={loyaltyMembersDayBannerButtonComponent}
      imagePath={keychainImage}
    />
  );
};

BannerContent.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  membersDayEvent: PropTypes.string
};

export default withTranslation(BannerContent);
